import { cn } from '@/shared/utils/cn';
import React, { ReactNode } from 'react';

interface FulfillmentSectionProps {
    title: string;
    size?: 'sm' | 'lg' | 'xl';
    children: ReactNode;
}

export const FulfillmentSection: React.FC<FulfillmentSectionProps> = ({ title, size = 'sm', children }) => {
    return (
        <div
            className={cn('flex flex-col items-center', {
                'w-[720px]': size === 'sm',
                'w-[1280px]': size === 'lg',
                'w-[1760px]': size === 'xl',
            })}
        >
            <h2 className="font-headline-lg mb-[40px] w-full max-w-[720px] [counter-increment:section] before:content-[counter(section)'.\0020']">
                {title}
            </h2>
            <div className="w-full">{children}</div>
            <hr className="border-divider mt-[40px] w-[720px]" />
        </div>
    );
};
